var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"h-100"},[(_vm.error)?_c('div',{key:"error",staticClass:"p-5"},[_c('BError',[_vm._v(_vm._s(_vm.error))])],1):_c('div',{key:"loading",staticClass:"bc-spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }